import { words } from "lodash";

const PublicName = (name) => {
  var names = words(name);
  if (names.length == 1) {
    return name;
  }
  var lastName = names.pop();
  if (lastName) {
    lastName = lastName.charAt(0);
  }
  names.push(lastName);
  return names.join(" ");
};

export default PublicName;



// WEBPACK FOOTER //
// ./src/utils/publicName.js